import React from 'react';
import {
    AutocompleteInput,
    ImageField,
    ImageInput,
    ReferenceField,
    ReferenceInput,
    required,
    TextField
} from 'react-admin';
import {Grid} from '@material-ui/core'
import {EVehicleTypeInput} from "./EVihicleType";

const ParkingVehicleFields = (props) => {
    return (
        <React.Fragment>
            <Grid item xs={12} sm={6}>
                {props.record?.id ?
                    <ReferenceField source="partnerId" reference={"parkingPartners"} {...props} >
                        <TextField source="name"/>
                    </ReferenceField>
                    :
                    <ReferenceInput source="partnerId"
                                    validate={required()}
                                    reference="parkingPartners">
                        <AutocompleteInput optionText="name"/>
                    </ReferenceInput>
                }
            </Grid>
            <Grid item xs={12} sm={6}>
                {props.record?.id ?
                    <ReferenceField source="customerId" reference={"customers"} {...props} >
                        <TextField source="displayName"/>
                    </ReferenceField>
                    :
                    <ReferenceInput source="customerId" reference={"customers"}
                                    validate={[required()]} allowEmpty>
                        <AutocompleteInput optionText={'displayName'}/>
                    </ReferenceInput>
                }
            </Grid>
            <Grid item xs={12} sm={6}>
                <EVehicleTypeInput source="vehicleType" validate={required()} {...props}/>
            </Grid>
            <Grid item xs={12} sm={6}>
                <ImageInput source="file" {...props} validate={!!props.record?.id ? [] : [required()]}
                            accept='.png,.jpg,.jpeg'>
                    <ImageField source="src" title="title"/>
                </ImageInput>
            </Grid>
        </React.Fragment>
    )
}
export default ParkingVehicleFields